import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import classNames from "classnames";
import styles from "./Typography.module.scss";
const variantMapping = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    body1: "p",
    body2: "p",
};
export const Typography = forwardRef(({ as, variant, className, dataTestId, children, weight = "regular" }, ref) => {
    const Component = as || (variant && variantMapping[variant]) || "span";
    return (_jsx(Component, { ref: ref, className: classNames(styles[`variant-${variant}`], styles[`font-weight-${weight}`], className), "data-testid": dataTestId, children: children }));
});
//# sourceMappingURL=Typography.js.map